import BackendService from './BackendService';

export default class FeedMappingService {
  static getFeedMappings() {
    return BackendService.get('/feedMappings/');
  }

  static getFeedMapping(feedMappingId) {
    return BackendService.get(`/feedMappings/${feedMappingId}`);
  }

  static createFeedMapping(feedMapping) {
    return BackendService.post('/feedMappings/', { body: feedMapping });
  }

  static updateFeedMapping(feedMapping) {
    return BackendService.put(`/feedMappings/${feedMapping.id}`, {
      body: feedMapping,
    });
  }

  static deleteFeedMapping(feedMappingId) {
    return BackendService.delete(`/feedMappings/${feedMappingId}`);
  }
}
